/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/zendesk" */ '@atlassian/logo-third-party/zendesk'
		).then((m) => m.ZendeskIcon),
	{ moduleId: '@atlassian/logo-third-party/zendesk' },
);

const LazyZendeskIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-zendesk" */ './utils').then((m) => m.ZendeskIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/zendesk/icon' },
);

const LazyZendeskSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-zendesk-search-result" */ './utils').then(
			(m) => m.ZendeskSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ZendeskIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyZendeskIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ZendeskSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyZendeskSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
